import {PRODUCTION} from "@irati/utils/constants/environment"
import env from "@irati/utils/env"

export const getIntercomKey = () => {
  if (env.ENVIRONMENT_NAME === PRODUCTION) {
    return "z3rmv6xv" // Old prod instance: effyqzrr
  }
  // Testing new instance on staging
  return "vbcvngdn" // Old test instance: s2maiwk8
}

export const getIntercomBaseUrl = () => {
  return "https://api-iam.eu.intercom.io"
}
